<template>
  <div class="primary--text text--darken-2">
    <v-tooltip bottom class="chanspy" v-if="canChanSpy">
      <template v-slot:activator="{ on }">
        <v-btn color="green" dark x-small v-on="on" icon outlined @click="chanspyCall">
          <v-icon x-small>mdi-headphones</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('queues.agent.chanspy') }}</span>
    </v-tooltip>
    <span class="ml-2 timer">
      <v-icon small color="primary darken-2">mdi-clock-outline</v-icon>
      {{onCallTime | formatTime}}
    </span>
    <v-icon small color="primary darken-2">mdi-account-voice</v-icon>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <span v-on="on" class="text-truncate text-no-wrap caller">
          &lt;{{call.callerNum}}&gt; {{call.callerName}}
        </span>
      </template>
      <span>{{ $t('queues.agent.callerCall') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'queue-agents-calls',
  props: {
    call: {
      type: Object,
      required: true
    },
    agentExten: {
      type: String,
      required: true
    },
    agentSubid: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      onCallTime: 0
    }
  },
  timer: 'updateCallerTime',
  computed: {
    ...mapGetters({ permChanSpy: 'permissions/canChanSpy' }),
    canChanSpy: function () {
      return this.permChanSpy(this.agentSubid)
    }
  },
  methods: {
    ...mapActions({
      chanspy: 'sipua/chanspy'
    }),
    updateCallerTime: function () {
      this.onCallTime = Math.ceil((Date.now() - this.call.utime) / 1000)
    },
    chanspyCall: function () {
      this.dbg(`Chanspy call to ${this.agentExten}, channel: ${this.call.channel}`)
      this.chanspy({ num: this.agentExten, chan: this.call.channel })
    }
  }
}
</script>

<style scoped>
</style>
